import styled from '@emotion/styled';

export const SvgStyled = styled.div`
  & svg{
    width: 24px;
    height: 24px;
  }
`
